import {
  getCurrentProfileSelect,
  getValueReduxUtil,
  loadInstanceReduxAction,
  PROFILES_ACTION
} from '@gymaholic/packages'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import { PREFERENCES_MODEL_CLASS_NAME } from 'modules/training/models/preferences/constants'
import updateCurrentPreferencesAction
from 'modules/training/modules/preferences/actions/update-current'
import { PREFERENCES_PATH } from 'modules/training/modules/preferences/constants'
import {
  getCurrentPreferencesSelect,
  getPreferenceByIdSelector
} from 'modules/training/modules/preferences/selectors'
import { logUtil } from 'packages/src'

function loadPreferencesAction () {
  return async (
    dispatch,
    getState
  ) => {
    if (getCurrentPreferencesSelect(getState())) {
      logUtil('loadPreferencesAction')
        .info('[noop] preferences already loaded')
      return
    }

    const profile = getCurrentProfileSelect(getState())
    if (!profile) {
      logUtil('loadPreferencesAction')
        .info('[noop] no profile')
      return
    }

    try {
      const res = await dispatch(loadInstanceReduxAction({
        type: PROFILES_ACTION.LOAD_PREFERENCES,
        payload: {
          endpoint: '/preferences',
          domainListPath: PREFERENCES_PATH.ALL,
          data: {
            className: PREFERENCES_MODEL_CLASS_NAME
          }
        }
      }))

      const id = getValueReduxUtil(
        res,
        'data.preferences.id'
      )
      const preference = getPreferenceByIdSelector(id)(
        getState())
      dispatch(updateCurrentPreferencesAction(preference))
    } catch (error) {
      logUtil('loadPreferencesAction')
        .error(
          `loading preferences failed for profile with id ${getIdReduxUtil(profile)} `,
          error
        )
    }
  }
}

export default loadPreferencesAction
